import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../api/api";
import { Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "@themesberg/react-bootstrap";
import CardLayout from "../Layout/CardLayout";
import Ranked from "../Ciem/Ranked";

const Legal = ({ ciemId }) => {
    const [product, setProduct] = useState(null);
    const [editedDescription, setEditedDescription] = useState('');
    const [editedEmpresa, setEditedEmpresa] = useState('');
    const [rankedForm, setRankedForm] = useState([]);


    const fetchProduct = async () => {
        try {
            const response = await axiosInstance.get(`/ciem/${ciemId}`);
            console.log("Producto obtenido:", response.data.data);

            setProduct(response.data.data); // Se actualiza el estado, pero NO se puede usar inmediatamente

            const ranked = await axiosInstance.get('/detailoption/option/value/rankedThree');
            console.log("Calificación obtenida:", ranked.data.data[0]);

            setRankedForm(ranked.data.data[0]);

        } catch (error) {
            console.error('Error fetching product:', error);
        }
    };

    // useEffect para actualizar descripción y empresa cuando `product` cambie
    useEffect(() => {
        if (product) {
            console.log("Actualizando descripción y empresa");
            setEditedDescription(product.legal);
            setEditedEmpresa(product.descripcionEmpresa);
        }
    }, [product]); // Se ejecuta cuando `product` cambia

    // useEffect para obtener el producto cuando cambia `ciemId`
    useEffect(() => {
        if (ciemId) {
            fetchProduct();
        } else {
            setProduct(null);
        }
    }, [ciemId]); // Se ejecuta cuando `ciemId` cambia


    const handleSaveEmpresa = async () => {
        try {
            await axiosInstance.patch(
                `/ciem/descripcionEmpresa/${product.id}`,
                editedEmpresa,
                { headers: { 'Content-Type': 'application/json' } }
            );
            setProduct({ ...product, descripcionEmpresa: editedEmpresa });
            alert('Empresa nueva o a reorganizar guardada correctamente');
        } catch (error) {
            console.error('Error updating empresa:', error);
            alert('Error guardando: ' + error);
        }
    };

    const handleSave = async () => {
        try {
            alert("Se ha actualizado el marco legal del negocio")
            product.legal = editedDescription
            await axiosInstance.post(`/ciem/`, product);
            await fetchProduct();
        } catch (error) {
            console.error('Error updating product:', error);
        }
    };

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId} />

    const formLegal = <Form>
        <Form.Group className="mb-3">
            <Form.Control
                as="textarea"
                rows={5} // Aumentar las filas para que sea más grande
                value={editedDescription}
                onChange={(e) => setEditedDescription(e.target.value)}
                maxLength={1000}
                style={{ width: '100%' }} // Ocupar el 100% del ancho
            />
        </Form.Group>
        <Button variant="primary" onClick={handleSave}>Guardar</Button>
    </Form>

    const empresaForm = <Form>
        <Form.Group className="mb-3">
            <Form.Control
                as="textarea"
                rows={5} // Aumentar las filas para que sea más grande
                value={editedEmpresa}
                onChange={(e) => setEditedEmpresa(e.target.value)}
                maxLength={1000}
                style={{ width: '100%' }} // Ocupar el 100% del ancho
            />
        </Form.Group>
        <Button variant="primary" onClick={handleSaveEmpresa}>Guardar</Button>
    </Form>

    return (
        <div className="container-fluid"> {/* Contenedor para ocupar todo el ancho */}
            <CardLayout value={"empresaTitulo"} tablaComponent={empresaForm} />
            <CardLayout value={"legalTitulo"} tablaComponent={formLegal} />
            <CardLayout value={"rankedThree"} tablaComponent={calificacion} />
        </div>
    );
};

export default Legal;